import { render, staticRenderFns } from "./DishesManagement.vue?vue&type=template&id=785a9e06&scoped=true"
import script from "./DishesManagement.vue?vue&type=script&lang=ts"
export * from "./DishesManagement.vue?vue&type=script&lang=ts"
import style0 from "./DishesManagement.vue?vue&type=style&index=0&id=785a9e06&prod&lang=css"
import style1 from "./DishesManagement.vue?vue&type=style&index=1&id=785a9e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785a9e06",
  null
  
)

export default component.exports